import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { Mail, Linkedin } from 'lucide-react';
export function ContactSection() {
  const {
    t
  } = useLanguage();
  return <section id="contact" className="py-20 sm:py-40 bg-[#152c61] px-4 sm:px-6 lg:px-8 text-white text-center relative overflow-hidden" data-id="element-35">
      {/* Radial Gradient Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] opacity-50 blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, #1a3470, transparent)'
    }} data-id="element-36" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-37">
        <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full border border-white/10 bg-white/5 mb-8 backdrop-blur-sm" data-id="element-38">
          <span className="text-[10px] font-bold text-white/60 uppercase tracking-[0.2em]" data-id="element-39">
            {t.nav.contact}
          </span>
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 sm:mb-8 tracking-tight leading-tight" data-id="element-40">
          {t.contact.title}
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-white/60 mb-10 sm:mb-16 max-w-2xl mx-auto leading-relaxed font-light" data-id="element-41">
          {t.contact.subtext}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-42">
          <a href="mailto:contact@lbg-consulting.com" className="group relative inline-flex items-center px-8 py-4 bg-white text-[#152c61] font-semibold text-base rounded-full overflow-hidden shadow-[0_4px_20px_rgba(255,255,255,0.1)] hover:shadow-[0_8px_30px_rgba(255,255,255,0.2)] hover:-translate-y-0.5 transition-all duration-300" data-id="element-43">
            <span className="relative z-10 flex items-center" data-id="element-44">
              <Mail className="mr-3 h-4 w-4" data-id="element-45" />
              {t.contact.cta}
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#fcdce1]/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700" data-id="element-46" />
          </a>

          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-8 py-4 bg-transparent border border-white/10 text-white font-medium text-base rounded-full hover:bg-white/5 hover:border-white/20 transition-all duration-300" data-id="element-47">
            <Linkedin className="mr-3 h-4 w-4" data-id="element-48" />
            LinkedIn
          </a>
        </div>
      </div>
    </section>;
}